import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import PortfolioLayout from './portfolio/PortfolioLayout';
import NewsPipelineCaseStudy from './portfolio/NewsPipelineCaseStudy';
import RouteMetadata from './portfolio/RouteMetadata';
import {
  AboutPage,
  ArtPage,
  ContactPage,
  HomePage,
  LabPage,
  NotFoundPage,
  ProjectPage,
  ResumePage,
  WorkIndexPage,
} from './portfolio/PortfolioPages';

const TvExperience = lazy(() => import('./features/tv/TvExperience'));

function App() {
  return (
    <BrowserRouter>
      <RouteMetadata />
      <Routes>
        <Route
          path="/ascii-tv"
          element={(
            <Suspense fallback={<div className="tv-route-loading">Tuning ASCII-TV…</div>}>
              <TvExperience />
            </Suspense>
          )}
        />
        <Route path="/tv" element={<Navigate to="/ascii-tv" replace />} />
        <Route element={<PortfolioLayout />}>
          <Route index element={<HomePage />} />
          <Route path="work" element={<WorkIndexPage />} />
          <Route path="work/lullabai" element={<ProjectPage projectId="lullabai" />} />
          <Route path="work/remote-studio" element={<ProjectPage projectId="remote-studio" />} />
          <Route path="work/mf-1" element={<ProjectPage projectId="mf-1" />} />
          <Route path="art" element={<ArtPage />} />
          <Route path="lab" element={<LabPage />} />
          <Route path="lab/news-pipeline" element={<NewsPipelineCaseStudy />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="bio" element={<AboutPage />} />
          <Route path="resume" element={<ResumePage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
